import React from 'react';
import { motion } from 'motion/react';
import { FolderPlus } from '@phosphor-icons/react';

/**
 * Floating selection bar shown at bottom of screen during multiselect mode.
 *
 * Props:
 *   count: number of selected items
 *   onAddToCollection: callback to open collection picker
 *   onCancel: callback to exit select mode
 */
export default function SelectionBar({ count, onAddToCollection, onCancel }) {
  return (
    <motion.div
      className="selection-bar"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
    >
      <span className="selection-bar-count">{count} selected</span>
      <button
        className="btn btn-primary btn-sm"
        onClick={onAddToCollection}
        disabled={count === 0}
      >
        <FolderPlusIcon />
        Add to collection
      </button>
      <button className="btn btn-ghost btn-sm" onClick={onCancel}>
        Cancel
      </button>
    </motion.div>
  );
}

function FolderPlusIcon() {
  return <FolderPlus size={16} />;
}
